(()=> {
  document.addEventListener('DOMContentLoaded', () => {
    const accordionBtn = document.querySelector('.accordion-review');
    const panel = accordionBtn?.nextElementSibling;
    if (!panel) return;

    const observeForm = (form) => {
        const onChange = () => {
        const isVisible = getComputedStyle(form).display !== 'none';

        if (!accordionBtn.classList.contains('active')) return;

        if (isVisible) {
            panel.style.maxHeight = 'none';
        } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
        }
        };

        onChange();

        const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
            if (m.attributeName === 'style') {
            onChange();
            }
        });
        });

        observer.observe(form, { attributes: true, attributeFilter: ['style'] });
    };

    const waitForForm = new MutationObserver(() => {
        const form = panel.querySelector('.jdgm-form-wrapper');
        if (form) {
        observeForm(form);
        waitForForm.disconnect();
        }
    });

    waitForForm.observe(panel, { childList: true, subtree: true });
  });
})()